import { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../../context/SocketContext'
import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas'
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'

import LoadingOverlay from '../../components/LoadingOverlay'
import { NoAcceso } from '../../components/NoAcceso'
import { serverApi } from '../../api'
import { CrearUbicacionModal } from './components/CrearUbicacionModal'



const pasarMayusculas = (ev) => {
    ev.target.value = ev.target.value.toUpperCase();
}

const paginacionBtn = {
    width: 34, height: 34, borderRadius: 10, border: '1.5px solid #e2e8f0',
    background: '#ffffff', color: 'var(--color-primario-texto)', cursor: 'pointer', fontSize: 12,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
}


const MySwal = withReactContent(Swal);
const sweet = (title, html, icon) => { MySwal.fire({ title, html, icon, confirmButtonColor: 'var(--color-primario)', timer: 15000 }) }
const sweetConfirm = (title, html, icon) => {
    return MySwal.fire({

        title,
        html,
        icon,
        confirmButtonText: 'Ok',
        confirmButtonColor: 'var(--color-primario)',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
    })
}


export const UbicacionesCreacion = () => {

    let [usuario] = useState(getUsuarioStorage());
    const pantallas = useGetPantallas();
    const navigate = useNavigate();
    const { socket } = useContext(SocketContext);

    useHideMenu(false);

    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    // Modal de marquee por sede
    const [showMarqueeModal, setShowMarqueeModal] = useState(false);
    const [marqueeEditItem, setMarqueeEditItem] = useState(null);
    const [marqueeText, setMarqueeText] = useState('');
    const [savingMarquee, setSavingMarquee] = useState(false);

    // const [ubicaciones, setUbicaciones ] = useState([]);


    const [searchInput, setSearchInput] = useState('');

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'nombreUbicacion',
        sortDir: 'asc',
    });
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const totalPages = Math.max(1, Math.ceil(total / query.limit));
    const [resumenSedes, setResumenSedes] = useState({ maxSedes: 0, sedesRegistradas: 0, sedesDisponibles: 0 });

    const { maxSedes, sedesRegistradas, sedesDisponibles } = resumenSedes;
    const limiteAlcanzado = maxSedes > 0 && sedesDisponibles <= 0;


    useEffect(() => {
        if (!usuario?.uidUsuario) navigate('/Ingreso');
    }, [usuario, navigate]);


    //Carga inicial de los Ubicaciones
    const loadUbicaciones = useCallback(async () => {

        const codigoEntidad = usuario.codigoEntidad;
        if (!codigoEntidad) return;

        try {
            setIsLoading(true);

            const resp = await serverApi.post('/ubicaciones/lista-ubicaciones', {
                ...query,
                codigoEntidad,
            });

            setData(resp.data.listaUbicaciones || []);
            setTotal(resp.data.total || 0);
            setResumenSedes({
                maxSedes: resp.data.maxSedes || 0,
                sedesRegistradas: resp.data.sedesRegistradas || 0,
                sedesDisponibles: (resp.data.sedesDisponibles ?? Math.max(0, (resp.data.maxSedes || 0) - (resp.data.sedesRegistradas || 0))),
            });

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }, [query, usuario]);

    useEffect(() => {
        loadUbicaciones();
    }, [loadUbicaciones]);

    useEffect(() => {

        if (!socket) return;


        const handler = (lista) => {
            setData(lista.listaUbicaciones);
            setTotal(lista.total || 0);
            setResumenSedes({
                maxSedes: lista.maxSedes || 0,
                sedesRegistradas: lista.sedesRegistradas || 0,
                sedesDisponibles: (lista.sedesDisponibles ?? Math.max(0, (lista.maxSedes || 0) - (lista.sedesRegistradas || 0))),
            });
        };

        socket.on('lista-ubicaciones', handler);

        return () => socket.off('lista-ubicaciones', handler);

    }, [socket])

    // const handleSearch = (ev) => {
    //     setQuery(prev => ({
    //         ...prev,
    //         search: ev.target.value,
    //         page: 1
    //     }));
    // };

    useEffect(() => {
        const timeout = setTimeout(() => {

            if (searchInput.trim().length > 0 && searchInput.trim().length < 2) return;

            setQuery(prev => {
                if (prev.search === searchInput) return prev; // 🔥 evita re-render

                return {
                    ...prev,
                    search: searchInput,
                    page: 1
                };
            });

        }, 1000);

        return () => clearTimeout(timeout);

    }, [searchInput]);

    const paginate = (page) => {
        if (page < 1 || page > totalPages) return;

        setQuery(prev => ({
            ...prev,
            page
        }));
    };

    const handleSort = (field) => {
        setQuery(prev => ({
            ...prev,
            sortBy: field,
            sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc'
        }));
    };



    const registraUbicacion = async (datos) => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');

        try {

            setIsLoading(true);
            const res = await serverApi.post(
                `/ubicaciones/registra-ubicacion`,
                {
                    ...query,
                    ...datos,
                    codigoEntidad,

                }
            );

            if (res.data.ok === false) {
                sweet('', res.data.resp, 'error');
            } else {
                sweet('', res.data.resp, 'success');
                setShowModal(false);
                loadUbicaciones();
            }


        } catch (error) {
            // sweet('Atención!', res[1], 'error');
            console.error(error);
        } finally {
            setIsLoading(false);

        }


    }

    const editaUbicacion = async (ev, ideUbicacion) => {

        const campo = ev.target.id.split("_")[0];
        const valor = (ev.target.type === 'checkbox') ? ev.target.checked : ev.target.value;
        const valorAnterior = (ev.target.type === 'checkbox') ? ev.target.checked : ev.target.defaultValue;


        if (valor !== valorAnterior || ev.target.type === 'checkbox') {

            const confirmacion = await sweetConfirm("Atención", "Esta seguro de Modificar el registro?", "warning");
            if (!confirmacion.value) {

                // restaurar visualmente checkbox
                if (ev.target.type === 'checkbox') {
                    ev.target.checked = valorAnterior;
                } else {
                    ev.target.value = valorAnterior;
                }

                return;
            }

            try {
                const codigoEntidad = usuario.codigoEntidad;

                if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');

                const rest = await serverApi.post(
                    `/ubicaciones/edita-ubicacion`,
                    {
                        ...query,
                        campo,
                        valor,
                        codigoEntidad,
                        ideUbicacion,
                    }
                );

                console.log(rest);


                if (rest.data.ok === false) {
                    console.log(rest.data.resp);

                    sweet('', rest.data.resp, 'error');
                } else {
                    sweet('', rest.data.resp, 'success');
                    loadUbicaciones();
                }


            } catch (error) {
                console.error(error);

            } finally {
                setIsLoading(false);
            }
        }


    }



    const handleBlurCampo = (ev, ideUbicacion) => {
        ev.target.style.borderColor = '#e2e8f0';
        ev.target.style.boxShadow = 'none';
        editaUbicacion(ev, ideUbicacion);
    };

    const abrirMarqueeModal = (item) => {
        setMarqueeEditItem(item);
        setMarqueeText(item.textoMarquee || '');
        setShowMarqueeModal(true);
    };

    const guardarMarquee = async () => {
        if (!marqueeEditItem) return;
        try {
            setSavingMarquee(true);
            const rest = await serverApi.post(
                `/ubicaciones/edita-ubicacion`,
                {
                    ...query,
                    campo: 'textoMarquee',
                    valor: marqueeText,
                    codigoEntidad: usuario.codigoEntidad,
                    ideUbicacion: marqueeEditItem.ideUbicacion,
                }
            );
            if (rest.data.ok === false) {
                sweet('', rest.data.resp, 'error');
            } else {
                sweet('', 'Mensaje marquee actualizado', 'success');
                setShowMarqueeModal(false);
                loadUbicaciones();
            }
        } catch (error) {
            console.error(error);
            sweet('', 'Error al guardar el mensaje', 'error');
        } finally {
            setSavingMarquee(false);
        }
    };



    if (usuario.uidUsuario === null) {
        return (
            <>
            </>
        )
    }
    else if (!pantallas.includes("creacionubicaciones")) {
        return (<NoAcceso />)
    }
    else {

        const pctCupo = limiteAlcanzado
        ? 100
        : maxSedes > 0
            ? Math.round((sedesRegistradas / maxSedes) * 100)
            : 0;

    return (
        <>
            {isLoading && <LoadingOverlay />}
            <div className={`content ${isLoading ? 'opacity' : ''} p-4`} style={{ minHeight: '100vh', fontFamily: "'Inter', Arial, sans-serif" }}>

                <div style={{ maxWidth: 1080, margin: '0 auto' }}>

                    <CrearUbicacionModal
                        show={showModal}
                        onClose={() => setShowModal(false)}
                        onSave={(data) => {
                            registraUbicacion(data)
                        }}
                        maxSedes={maxSedes}
                        sedesRegistradas={sedesRegistradas}
                        sedesDisponibles={sedesDisponibles}
                        limiteAlcanzado={limiteAlcanzado}
                    />

                    {/* Modal de Mensaje Marquee por Sede */}
                    {showMarqueeModal && (
                        <div style={{
                            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                            background: 'rgba(15, 23, 42, 0.65)', backdropFilter: 'blur(6px)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            zIndex: 9999, padding: 20, fontFamily: "'Inter', Arial, sans-serif",
                        }}>
                            <div style={{
                                background: '#ffffff', borderRadius: 20, width: '100%',
                                maxWidth: 560, boxShadow: '0 25px 60px rgba(0,0,0,0.25)',
                                border: '1px solid #e2e8f0',
                            }}>
                                <div style={{
                                    background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-primario-oscuro) 100%)',
                                    padding: '20px 24px', color: 'var(--color-primario-contraste)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                    borderRadius: '20px 20px 0 0',
                                }}>
                                    <div>
                                        <h4 style={{ margin: 0, fontWeight: 800, fontSize: 17 }}>Mensaje Marquee</h4>
                                        <p style={{ margin: '4px 0 0', opacity: 0.85, fontSize: 12 }}>
                                            Sede: {marqueeEditItem?.nombreUbicacion} ({marqueeEditItem?.codigoUbicacion})
                                        </p>
                                    </div>
                                    <button onClick={() => setShowMarqueeModal(false)} style={{
                                        background: 'rgba(255,255,255,0.15)', border: 'none', color: 'var(--color-primario-contraste)',
                                        width: 34, height: 34, borderRadius: '50%', fontSize: 16, cursor: 'pointer',
                                    }}>✕</button>
                                </div>
                                <div style={{ padding: 24 }}>
                                    <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
                                        Mensaje que se mostrará en la barra animada (marquee) de las pantallas de llamado de esta sede
                                    </label>
                                    <textarea
                                        value={marqueeText}
                                        onChange={(e) => setMarqueeText(e.target.value)}
                                        placeholder="Ej: RECUERDA: Alista los siguientes documentos para agilizar tu atención..."
                                        rows={4}
                                        style={{
                                            width: '100%', padding: '10px 12px', borderRadius: 10,
                                            border: '1.5px solid #cbd5e1', fontSize: 14, resize: 'vertical',
                                            minHeight: 80, boxSizing: 'border-box',
                                            fontFamily: "'Inter', Arial, sans-serif",
                                        }}
                                    />
                                    <div style={{ fontSize: 11, color: '#64748b', marginTop: 4 }}>
                                        Si este campo está vacío, se usará el mensaje configurado a nivel de empresa. Si la empresa tampoco tiene mensaje, no se muestra marquee.
                                    </div>
                                    <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 18 }}>
                                        <button
                                            onClick={() => setShowMarqueeModal(false)}
                                            style={{
                                                padding: '10px 18px', borderRadius: 10, border: '1.5px solid #cbd5e1',
                                                background: 'white', color: '#475569', fontWeight: 700, cursor: 'pointer', fontSize: 13,
                                            }}
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            onClick={guardarMarquee}
                                            disabled={savingMarquee}
                                            style={{
                                                padding: '10px 22px', borderRadius: 10, border: 'none',
                                                background: savingMarquee ? '#94a3b8' : 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                                                color: 'var(--color-marca-contraste)', fontWeight: 800, cursor: savingMarquee ? 'not-allowed' : 'pointer',
                                                fontSize: 13, boxShadow: savingMarquee ? 'none' : '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                                            }}
                                        >
                                            {savingMarquee ? 'Guardando...' : 'Guardar Mensaje'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div style={{
                        background: 'white', borderRadius: 16, overflow: 'hidden',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0',
                    }}>

                        {/* Header de la card */}
                        <div style={{
                            padding: '20px 26px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0',
                            display: 'flex', flexWrap: 'wrap', gap: 14, justifyContent: 'space-between', alignItems: 'center',
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                                <div style={{
                                    width: 46, height: 46, borderRadius: 14,
                                    background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                                    color: 'var(--color-marca-contraste)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: 20, boxShadow: '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                                }}>
                                    <i className="fa-solid fa-map-location-dot"></i>
                                </div>
                                <div>
                                    <h4 style={{ margin: 0, fontWeight: 800, fontSize: 18, color: '#0f172a' }}>Ubicaciones / Sedes</h4>
                                    <p style={{ margin: '2px 0 0', fontSize: 12.5, color: '#64748b' }}>
                                        Administra las sedes de tu entidad y su cupo contratado
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                                <span style={{
                                    background: limiteAlcanzado ? '#fee2e2' : '#ecfdf5',
                                    color: limiteAlcanzado ? '#b91c1c' : '#047857',
                                    fontWeight: 800, padding: '6px 14px', borderRadius: 12, fontSize: 13,
                                }}>
                                    {sedesRegistradas} / {maxSedes} sedes
                                </span>
                                <button
                                    onClick={() => setShowModal(true)}
                                    disabled={limiteAlcanzado}
                                    title={limiteAlcanzado ? 'Límite de sedes alcanzado. No se pueden crear más sedes.' : 'Crear una nueva sede'}
                                    style={{
                                        padding: '11px 20px', borderRadius: 12, border: 'none',
                                        background: limiteAlcanzado ? '#94a3b8' : 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                                        color: 'var(--color-marca-contraste)', fontWeight: 800, cursor: limiteAlcanzado ? 'not-allowed' : 'pointer', fontSize: 13.5,
                                        boxShadow: limiteAlcanzado ? 'none' : '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                                        display: 'inline-flex', alignItems: 'center', gap: 8,
                                    }}
                                >
                                    <i className="fa-solid fa-plus"></i> Crear Sede
                                </button>
                            </div>
                        </div>

                        {/* Barra de herramientas */}
                        <div style={{
                            padding: '16px 26px', borderBottom: '1px solid #f1f5f9',
                            display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'center', justifyContent: 'space-between',
                        }}>
                            <div style={{ position: 'relative', flex: 1, maxWidth: 420, minWidth: 220 }}>
                                <i className="fa-solid fa-magnifying-glass" style={{
                                    position: 'absolute', left: 13, top: '50%', transform: 'translateY(-50%)',
                                    color: '#94a3b8', fontSize: 13,
                                }} />
                                <input
                                    type='text'
                                    placeholder='Buscar por código o nombre...'
                                    maxLength={20}
                                    value={searchInput}
                                    onChange={(ev) => setSearchInput(ev.target.value)}
                                    style={{
                                        width: '100%', padding: '10px 12px 10px 38px', borderRadius: 10,
                                        border: '1.5px solid #e2e8f0', fontSize: 13.5, outline: 'none',
                                        background: '#f8fafc', transition: 'border-color .15s, background .15s',
                                    }}
                                    onFocus={(e) => { e.target.style.borderColor = 'var(--color-primario)'; e.target.style.background = '#ffffff'; }}
                                    onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.background = '#f8fafc'; }}
                                />
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <span style={{
                                    fontSize: 12.5, fontWeight: 800,
                                    color: limiteAlcanzado ? '#b91c1c' : '#047857',
                                }}>
                                    {limiteAlcanzado ? 'Sin cupo disponible' : `${sedesDisponibles} disponibles`}
                                </span>
                                <div style={{ width: 120, height: 8, borderRadius: 999, background: '#e2e8f0', overflow: 'hidden' }}>
                                    <div style={{
                                        height: '100%', borderRadius: 999, width: `${pctCupo}%`,
                                        background: limiteAlcanzado ? '#ef4444' : 'linear-gradient(90deg, #10b981 0%, var(--color-primario) 100%)',
                                        transition: 'width .3s ease',
                                    }} />
                                </div>
                            </div>
                        </div>

                        {/* Tabla */}
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                                <thead>
                                    <tr style={{ background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-primario-oscuro) 100%)', color: 'var(--color-primario-contraste)' }}>
                                        <th style={{ padding: '13px 22px', textAlign: 'left', fontWeight: 700, cursor: 'pointer', width: '50%' }} onClick={() => handleSort('codigoUbicacion')}>
                                            Código Ubicación
                                            {query.sortBy === 'codigoUbicacion' && <span className="ms-1">{query.sortDir === 'asc' ? '▲' : '▼'}</span>}
                                        </th>
                                        <th style={{ padding: '13px 22px', textAlign: 'left', fontWeight: 700, cursor: 'pointer', width: '40%' }} onClick={() => handleSort('nombreUbicacion')}>
                                            Ubicación
                                            {query.sortBy === 'nombreUbicacion' && <span className="ms-1">{query.sortDir === 'asc' ? '▲' : '▼'}</span>}
                                        </th>
                                        <th style={{ padding: '13px 22px', textAlign: 'center', fontWeight: 700, width: '10%' }}>
                                            Marquee
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length === 0 ? (
                                        <tr>
                                            <td colSpan="3" style={{ padding: '48px 20px', textAlign: 'center' }}>
                                                <div style={{ color: '#94a3b8', fontSize: 34, marginBottom: 8 }}>
                                                    <i className="fa-solid fa-map-location-dot"></i>
                                                </div>
                                                <div style={{ fontWeight: 700, color: '#64748b', fontSize: 15 }}>
                                                    No hay sedes registradas
                                                </div>
                                                <div style={{ color: '#94a3b8', fontSize: 13, marginTop: 4 }}>
                                                    Crea la primera sede para empezar a operar.
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        data.map((item, idx) => (
                                            <tr key={item.ideUbicacion} style={{
                                                borderBottom: '1px solid #f1f5f9',
                                                background: idx % 2 === 0 ? '#ffffff' : '#f8fafc',
                                            }}>
                                                <td style={{ padding: '10px 22px', width: '50%' }}>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        id={`codigoUbicacion_${item.ideUbicacion}`}
                                                        defaultValue={item.codigoUbicacion.toUpperCase()}
                                                        maxLength={45}
                                                        onBlur={(ev) => handleBlurCampo(ev, item.ideUbicacion)}
                                                        onChange={(ev) => pasarMayusculas(ev)}
                                                        style={{
                                                            padding: '8px 12px', borderRadius: 10,
                                                            border: '1.5px solid #e2e8f0', fontSize: 13.5,
                                                            transition: 'border-color .15s, box-shadow .15s',
                                                        }}
                                                        onFocus={(e) => { e.target.style.borderColor = 'var(--color-primario)'; e.target.style.boxShadow = '0 0 0 3px rgba(var(--color-primario-rgb),0.12)'; }}
                                                    />
                                                </td>
                                                <td style={{ padding: '10px 22px', width: '50%' }}>
                                                    <input
                                                        type='text'
                                                        className='form-control'
                                                        id={`nombreUbicacion_${item.ideUbicacion}`}
                                                        defaultValue={item.nombreUbicacion.toUpperCase()}
                                                        maxLength={45}
                                                        onBlur={(ev) => handleBlurCampo(ev, item.ideUbicacion)}
                                                        onChange={(ev) => pasarMayusculas(ev)}
                                                        style={{
                                                            padding: '8px 12px', borderRadius: 10,
                                                            border: '1.5px solid #e2e8f0', fontSize: 13.5,
                                                            transition: 'border-color .15s, box-shadow .15s',
                                                        }}
                                                        onFocus={(e) => { e.target.style.borderColor = 'var(--color-primario)'; e.target.style.boxShadow = '0 0 0 3px rgba(var(--color-primario-rgb),0.12)'; }}
                                                    />
                                                </td>
                                                <td style={{ padding: '10px 22px', width: '10%', textAlign: 'center' }}>
                                                    <button
                                                        onClick={() => abrirMarqueeModal(item)}
                                                        title={item.textoMarquee ? 'Editar mensaje marquee' : 'Agregar mensaje marquee'}
                                                        style={{
                                                            width: 34, height: 34, borderRadius: 10, border: 'none',
                                                            background: item.textoMarquee ? '#ecfdf5' : '#f1f5f9',
                                                            color: item.textoMarquee ? 'var(--color-primario)' : '#94a3b8',
                                                            cursor: 'pointer', fontSize: 14,
                                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                            transition: 'all .15s',
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-tv"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Paginación */}
                        <div style={{
                            padding: '14px 26px', borderTop: '1px solid #f1f5f9',
                            background: '#f8fafc', display: 'flex', flexWrap: 'wrap', gap: 10,
                            justifyContent: 'space-between', alignItems: 'center',
                        }}>
                            <span style={{ color: '#64748b', fontSize: 13 }}>
                                Registros: <b style={{ color: '#0f172a' }}>{total}</b>
                            </span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <span style={{ fontSize: 13, color: '#475569' }}>
                                    Página {query.page} de {totalPages}
                                </span>
                                <button
                                    onClick={() => paginate(query.page - 1)}
                                    disabled={query.page === 1}
                                    style={{ ...paginacionBtn }}
                                >
                                    <i className="fa-solid fa-chevron-left"></i>
                                </button>
                                <button
                                    onClick={() => paginate(query.page + 1)}
                                    disabled={query.page >= totalPages}
                                    style={{ ...paginacionBtn }}
                                >
                                    <i className="fa-solid fa-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
    }
}
